import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { EligibleTrainingItemsVM } from "@academy-context/shared/domain/types/eligible-training-items";

export const studentRetrieveEligibleTrainingItems = createAsyncThunk<EligibleTrainingItemsVM, void, { extra: Partial<Dependencies> }>(
  "student/retrieveEligibleTrainingItems",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getEligibleTrainingItems();
  },
);
